import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import '@integra/ui/tokens.css';
// React Flow's base stylesheet powers the visual campaign builder's canvas
// (§20.4). It is a third-party library baseline (handles, edges, viewport), the
// same category as the design tokens above — not per-component styling. Node
// appearance is themed with Tailwind utilities mapped to our tokens.
import '@xyflow/react/dist/style.css';
import './index.css';
import { App } from './App.js';

/**
 * SPA entry (§17.3). React 18 + React Router + TanStack Query.
 *
 * The two CSS imports here are the ONLY stylesheet imports in the app: design
 * tokens and the Tailwind directives. Components import no CSS (§21.4).
 */

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // A 401 is handled by the API client's silent refresh, so retrying here
      // would just multiply failed calls.
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 10_000,
    },
  },
});

const container = document.getElementById('root');
if (container === null) throw new Error('Root element #root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
